<div class="card fill-height fill-height-bg">
  <div class="card-body py-lg-5">
    <h3 class="text-center mb-lg-5">Select your organisation's bank account.</h3>
    <div class="row justify-content-center mb-4">
      <div class="col-md-6 col-xl-5 col-xxl-4">
        <div class="card shadow-lg">
          <div class="card-body">
            @if (accountingProvider()) {
              @if (showError) {
                <div class="alert alert-danger">
                  {{ showError }}
                </div>
              }
              @if (accountingProvider() === AccountingProviderCompany.XERO) {
                <div class="mb-3">
                  <img
                    src="./assets/accounting-logos/xero-select-source-acc.svg"
                    width="100%"
                    alt="Xero" />
                </div>
              }
              @if (!loading()) {
                <p class="text-muted my-3">
                  The bank account used to deposit money into Paystashio.<br />
                  <br />
                  Selecting the source account ensures your transfers reconcile seamlessly in
                  {{ accountingProvider() }}.
                </p>
                @if (hasSourceAccountOptions()) {
                  <label
                    class="form-label"
                    for="select_source">
                    Linked bank account
                  </label>
                  <ng-select
                    id="select_source"
                    [items]="sourceAccOptions"
                    [(ngModel)]="selectedAccount"
                    bindValue="id"
                    bindLabel="name"
                    notFoundText="No bank accounts found"
                    placeholder="Select bank account">
                  </ng-select>
                  <button
                    (click)="onSave()"
                    class="btn btn-primary mt-3 d-block w-100"
                    [disabled]="!selectedAccount">
                    {{ existingSourceAccount() ? 'Save' : 'Continue' }}
                  </button>
                  @if (existingSourceAccount()) {
                    <a
                      routerLink="/accounting/integrations"
                      class="btn btn-outline-dark mt-3 d-block w-100">
                      Cancel
                    </a>
                  }
                } @else {
                  @if (organisationNotSelected()) {
                    <div class="alert-warning alert text-sm mb-0">
                      <strong>No organisation has been linked.</strong><br />
                      In order to select a linked bank account, you need to <br />
                      <a routerLink="../select-organisation">link your {{ accountingProvider() }} organisation</a>
                      first.
                    </div>
                  } @else {
                    <div class="alert-warning alert text-sm mb-0">
                      <strong>Bank accounts could not be retrieved.</strong><br />
                      Please create a bank account in your accounting software and reconnect. If you have existing bank
                      accounts please disconnect and reconnect your {{ accountingProvider() }} connection
                      <a routerLink="/accounting/integrations">here</a>.
                    </div>
                  }
                }
              } @else if (hasStatusError()) {
                <div class="alert alert-danger">An error was detected with your accounting connection.</div>
              }
            } @else {
              <app-loader class="my-5"></app-loader>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
